import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedDashboardSample } from '../../voltage-with-speed.models';
import { getCorrelationValue } from './correlation.utils';

@Component({
  selector: 'app-voltage-speed-correlation',
  templateUrl: './correlation.component.html',
  styleUrls: ['./correlation.component.css']
})
export class VoltageSpeedCorrelationComponent implements OnChanges {
  @Input() samples: VoltageSpeedDashboardSample[] = [];
  @Input() movingOnly = false;
  @Input() title = '';
  @Input() description = '';

  value: number | null = null;

  ngOnChanges(): void {
    this.value = getCorrelationValue(this.samples, this.movingOnly);
  }
}
